// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body, html {
    margin: 0;
    overflow-x: hidden;
}

* {
    box-sizing: border-box;
}

#SearchAndFilter {
    text-align: center;
    width: 100%;
    border: 2px solid rgb(168, 168, 168);
    padding: 20px;
}

a {
    text-decoration: none;
}

a:link, a:visited {
    text-decoration: none;
}

@media (max-width: 768px) {
    .MuiAppBar-root {
        display: none;
    }
}

/* Hide scrollbar for Chrome, Safari and Opera */
.scrollbar-hide::-webkit-scrollbar {
    display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.scrollbar-hide {
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/App.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,oCAAoC;IACpC,aAAa;AACjB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA,gDAAgD;AAChD;IACI,aAAa;AACjB;;AAEA,4CAA4C;AAC5C;IACI,wBAAwB,GAAG,gBAAgB;IAC3C,qBAAqB,GAAG,YAAY;AACxC","sourcesContent":["body, html {\n    margin: 0;\n    overflow-x: hidden;\n}\n\n* {\n    box-sizing: border-box;\n}\n\n#SearchAndFilter {\n    text-align: center;\n    width: 100%;\n    border: 2px solid rgb(168, 168, 168);\n    padding: 20px;\n}\n\na {\n    text-decoration: none;\n}\n\na:link, a:visited {\n    text-decoration: none;\n}\n\n@media (max-width: 768px) {\n    .MuiAppBar-root {\n        display: none;\n    }\n}\n\n/* Hide scrollbar for Chrome, Safari and Opera */\n.scrollbar-hide::-webkit-scrollbar {\n    display: none;\n}\n\n/* Hide scrollbar for IE, Edge and Firefox */\n.scrollbar-hide {\n    -ms-overflow-style: none;  /* IE and Edge */\n    scrollbar-width: none;  /* Firefox */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
